<!--
    ***
    *   list-header
    *
-->
<div class="list-header">
</div>
<!--
    ***
    *   filter
    *
-->
<div ng-if="$ctrl.filterConfig && ($ctrl.filterConfig.alwaysShowFilter || ($ctrl.list.totalCount + $ctrl.list.count > 0))" class="list-filter">
    <div class="list-filter-fixed">
        <div class="list-filter-main">
            <div class="list-filter-tools" ng-show="$ctrl.showFilter" style="height: auto;overflow: visible;">
                <div centuri-list-filter class="list-filter-elements" config="$ctrl.filterConfig" callback="$ctrl.filterCallback">
                </div>
            </div>
            <div matrix-directive ng-if="$ctrl.isMatrixFilter" count="$ctrl.list.count" config="$ctrl.filterConfig" item-handler="$ctrl.itemHandler" item-loader="$ctrl.reloadForHeatmap"></div>
            <div class="list-filter-status">
                <div class="list-filter-status-text">{{$ctrl.statusText}}</div>
                <button ng-if="$ctrl.selectedIds.length > 0 || $ctrl.inverseSelection" class="list-deselect-items" ng-click="$ctrl.deselectItems()">{{$ctrl.deselectText()}}</button>
                <button ng-if="$ctrl.listOptions.canSelectAll && $ctrl.selectedIds.length === 0 && !$ctrl.inverseSelection" class="list-select-items" ng-click="$ctrl.selectAllItems()">{{$ctrl.selectText()}}</button>
            </div>
        </div>
    </div>
</div>
<!--
    ***
    *   pending change
    *
-->
<div class="changes-pending content" ng-show="$ctrl.hasPendingChanges" ng-click="$ctrl.reloadList()">{{"listrenderer.changes.pending"|translate}}</div>
<div class="changes-pending" ng-show="$ctrl.hasPendingChanges" ng-click="$ctrl.reloadList()"></div>
<!--
    ***
    *   did you mean
    *
-->
<div ng-if="$ctrl.list.count > 0 && $ctrl.searchSuggestion && $ctrl.searchSuggestion.didYouMean" class="search-suggestions">
    <div class="search-suggestions-fixed">
        <h3>
            <label>{{"didYouMean"|translate}}:</label>
            <a class="spell-sugg" ui-sref="read.search({ query: $ctrl.searchSuggestion.didYouMean })"><span ng-bind-html="$ctrl.searchSuggestion.markup"></span></a>
        </h3>
    </div>
</div>
<!--
    ***
    *   list
    *
-->
<ul class="list-ctx">
    <li ng-repeat="item in $ctrl.displayItems track by $index" ng-class="{updating: $ctrl.isUpdating(item), 'multi-start': $ctrl.startSelect===item}">
        <!-- empty item -->
        <div ng-if="item && item.loaded===undefined" class="list-item empty" ng-style="{ height: $ctrl.defaultItemHeight }"></div>
        <!-- loading item -->
        <div ng-if="item && item.loaded===false" class="list-item loading" ng-style="{ height: $ctrl.defaultItemHeight }">
            <div class="spinner-padding">
                <i class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            </div>
        </div>
        <!-- last item -->
        <div ng-if="item && item.endOfList && (!$ctrl.noEndOfList)" class="list-item end-of-list">
            <div ng-if="$ctrl.displayItems && $ctrl.list.count === 0">
                <h3>
                    {{$ctrl.noItemsInList}}
                    <div ng-if="$ctrl.searchSuggestion && $ctrl.searchSuggestion.didYouMean" class="search-suggestion">
                        <label>{{"didYouMean"|translate}}:</label>
                        <a ui-sref="{{$ctrl.currentState}}({ query: $ctrl.searchSuggestion.didYouMean })"><span ng-bind-html="$ctrl.searchSuggestion.markup"></span></a>
                    </div>
                </h3>
            </div>
            <div ng-if="!$ctrl.noEndOfList" class="end-image" ng-bind-html="$ctrl.endImage">
            </div>
        </div>
        <!-- loaded item -->
        <div ng-if="item && item.loaded===true && !item.endOfList" class="content-wrapper list-item loaded" ng-class="$ctrl.activeClassNames(item.id, item.index)" ng-click="$ctrl.itemClick($event, item.id, item)">
            <div ng-if="item.indicatorColor" class="indicator" ng-class="item.indicatorColor"></div>
            <div ng-if="$ctrl.listOptions.showCheckboxes" class="checkbox" ng-click="$ctrl.clickPassthru($event, item.id, item)">
                <c-checkbox checked="$ctrl.checkedBox(item.id)"></c-checkbox>
            </div>
            <div class="container">
                <c-list-item-container item-template="$ctrl.itemTemplate" list-item="item" highlight="$ctrl.highlightWords"></c-list-item-container>
            </div>
        </div>
    </li>
</ul>
<!--
    ***
    *   scroll
    *
-->
<div class="scroll-area"></div>
<nav class="flex-return" ng-click="$ctrl.toTop()"><i class="fa fa-level-up"></i></nav>
